<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ isLogin ? '登录' : '注册' }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="toggleForm">
          {{ isLogin ? '去注册' : '去登录' }}
        </el-button>
      </div>
      <div>
        <el-form
          class="demo-ruleForm"
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          v-if="isLogin"
          key='1'
        >
          <el-form-item label="用户名" prop="name">
            <el-input name="name" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input name="password" type="password" v-model="form.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="login">登录</el-button>
          </el-form-item>
        </el-form>

        <el-form
          class="demo-ruleForm"
          ref="registerForm"
          :model="registerForm"
          :rules="registerRules"
          label-width="100px"
          v-else
          key='2'
        >
        <el-form-item label="姓名" prop="truename">
            <el-input v-model="registerForm.truename"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="name">
            <el-input v-model="registerForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="registerForm.mobile"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input type="password" v-model="registerForm.pass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="registerForm.checkPass" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="register">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 5 || value.length > 20) {
        callback(new Error('密码长度在 5 到 20 个字符'));
      } else {
        if (this.registerForm.checkPass !== '') {
          this.$refs.registerForm.validateField('checkPass');
        }
        callback();
      }
    };
    
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      } else if (/[\u4e00-\u9fa5]/.test(value)) {
        callback(new Error('用户名不能包含中文'));
      } else if (/^\d+$/.test(value)) {
        callback(new Error('用户名不能是纯数字'));
      } else if (/^[\u4e00-\u9fa5\d]+$/.test(value)) {
        callback(new Error('用户名不能是中文加数字'));
      } else {
        callback();
      }
    };

    var validateMobile = (rule, value, callback) => {
      const mobileReg = /^1[3-9]\d{9}$/;
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!mobileReg.test(value)) {
        callback(new Error('请输入有效的手机号'));
      } else {
        callback();
      }
    };

    return {
      isLogin: true,
      form: {
        name: "",
        pass: ""
      },
      registerForm: {
        truename:'',
        name: "",
        mobile:'',
        pass: "",
        checkPass: ""
      },
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 5,
            max: 20,
            message: "密码长度在 5 到 20 个字符",
            trigger: "blur"
          }
        ]
      },
      registerRules: {
        truename: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        name: [{ required: true, validator: validateUsername, trigger: "blur" }],
        mobile: [{ required: true, validator: validateMobile, trigger: "blur" }],
        pass: [
          { required: true, validator: validatePass, trigger:  ['blur', 'change'] }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger:  ['blur', 'change'] }
        ]
      }
    };
  },
  methods: {
    toggleForm() {
      this.isLogin = !this.isLogin;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
        this.$refs.registerForm && this.$refs.registerForm.clearValidate();
      });
    },
    login() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http
            .get(
              `api/index/login?username=${this.form.name}&password=${this.form.pass}`
            )
            .then(response => {
              if (response.data.code == 200) {
                this.$message({
                  message: "登录成功",
                  type: "success"
                });
                localStorage.setItem("token", response.data.data.token);
                this.$router.push({ name: "home" });
              } else {
                this.$message({
                  message: "账号或密码错误",
                  type: "error"
                });
              }
            }).catch(e => {
              this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
              });
            });
        }
      });
    },
    register() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          // 这里替换为你的注册API
          this.$http
            .post('api/index/register', {
              truename: this.registerForm.name,
              username: this.registerForm.name,
              password: this.registerForm.pass,
              repassword: this.registerForm.checkPass,
              mobile: this.registerForm.mobile,
            })
            .then(response => {
              if (response.data.code == 200) {
                this.$message({
                  message: "注册成功，请登录",
                  type: "success"
                });
                this.isLogin = true;
              } else {
                this.$message({
                  message: response.data.msg || "注册失败",
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.$message({
                message: e.msg,
                type: "error"
              });
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  padding: 200px 0;
  width: 100%;
  height: 100%;
}

.box-card {
  width: 480px;
  margin: 0 auto;
}

.el-form-item__content {
  text-align: start;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>